<div [rvIsLoading]="preferences === null" class="page-body-wrapper">
  <form [formGroup]="notificationPreferencesForm" novalidate>
    <div class="mat-headline-4 preferences-title">Notification Preferences</div>
    <h3 class="preferences-subtitle">Please select your notification preferences for your library account.</h3>
    <div class="flex-row-wrap-col-responsive preferences-contact-row">
      <rv-input-form-field fieldName="notificationEmail" [externalLabel]="true" overrideLabel="Notification Email" [formGroup]="notificationPreferencesForm"/>
      <rv-select-form-field fieldName="phoneSms" [externalLabel]="true" overrideLabel="Mobile Phone Number" class="phone-sms-select-field"
                            [formGroup]="notificationPreferencesForm"
                            [options]="notificationPhoneOptions" [includeUndefinedOption]="true"/>
    </div>
    <rv-checkbox-form-field fieldName="smsTermsAccepted" [formGroup]="notificationPreferencesForm" overrideLabel="" [enabled]="hasSmsNumberSelected()">
      I agree to receive automated SMS/text notifications from my library related to my library account and circulation activity. Message frequency varies.
      Message and data rates may apply. I can manage notification preferences in my account or contact library staff for help. See
      <a href="https://www.simplicity-ils.com/sms-notification-terms" target="_blank" rel="noopener">SMS Notification Terms</a> and
      <a href="https://www.simplicity-ils.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.
    </rv-checkbox-form-field>
    <hr class="catalog-hr"/>
    <div class="mat-headline-4 preferences-title">Required Notice Delivery Method</div>
    <div class="flex-col flex-end-start">
      <div class="preferences-select-column">
        <ng-container *ngTemplateOutlet="selectField; context:
          { name: 'accountNotifications', label: 'Account related notices', toggle: false,
          description: 'Notices related to claims, charges, or account status.' }"/>
        <ng-container *ngTemplateOutlet="selectField; context:
          { name: 'expirationNotifications', label: 'Card Expiration', toggle: false,
          description: 'Library card expiration date notices.' }"/>
        <ng-container *ngTemplateOutlet="selectField; context:
          { name: 'renewNotifications', label: 'Renewals', toggle: false,
          description: 'Items that have been renewed.' }"/>
        <ng-container *ngTemplateOutlet="selectField; context:
          { name: 'holdNotifications', label: 'Hold Related', toggle: false,
          description: 'Holds ready for pickup, cancelled, or expiring holds.' }"/>
        <ng-container *ngTemplateOutlet="selectField; context:
          { name: 'receiptNotifications', label: 'Receipts', toggle: false,
          description: 'Payment receipts of any kind.' }"/>
        <ng-container *ngTemplateOutlet="selectField; context:
          { name: 'noticeNotifications', label: 'Notices', toggle: false,
          description: 'Items due back soon or are overdue.' }"/>
        <ng-container *ngTemplateOutlet="selectField; context:
          { name: 'itemRequestNotifications', label: 'Item Requests', toggle: false,
          description: 'Updates related to active item requests.' }"/>
      </div>
    </div>
    <!--    <div class="mat-display-1 preferences-title">Additional Notices</div>-->
    <!--    <div class="flex-col flex-end-start">-->
    <!--      <div class="preferences-select-column">-->
    <!--        <ng-container *ngTemplateOutlet="selectField; context:-->
    <!--          { name: 'localEvents', label: 'Local Library Events', toggle: true,-->
    <!--          description: 'Storybook time, sales, summer reading lists, etc.' }">-->
    <!--        </ng-container>-->
    <!--        <ng-container *ngTemplateOutlet="selectField; context:-->
    <!--          { name: 'monthlyNewsletter', label: 'Monthly Newsletter', toggle: true,-->
    <!--          description: 'Closure notifications, what’s new, etc.' }">-->
    <!--        </ng-container>-->
    <!--      </div>-->
    <!--    </div>-->

    <ng-template #selectField let-name="name" let-label="label" let-description="description" let-toggle="toggle">
      <div class="flex-row-wrap-col-responsive flex-start-space-between preferences-contact-row">
        <div class="flex-row">
          <div class="preferences-toggle">
            @if (toggle) {
              <mat-slide-toggle color="primary" [formControlName]="`${name}Toggle`"/>
            }
          </div>
          <div class="preferences-select-label-container">
            <h3 class="preferences-select-label">{{ label }}</h3>
            <div class="preferences-select-description">{{ description }}</div>
          </div>
        </div>

        <rv-select-form-field [fieldName]="name" [externalLabel]="true" overrideLabel="" [formGroup]="notificationPreferencesForm"
                              [options]="NOTIFICATION_PREFERENCE_SELECTION" [includeUndefinedOption]="false"
                              [disabledOptionDisplayValues]="disabledPreferences"/>

      </div>
    </ng-template>
    <div class="clear-for-footer"></div>
    <div class="save-footer mat-elevation-z6">
      <div class="save-footer-content flex-row flex-center-end">
        <div class="spacer"></div>
        <div class="button-row-right">
          <button mat-stroked-button class="ButtonSmallBlack save-button-group button-cancel"
                  (click)="cancel()" data-cy="on-hold-button">
            Cancel
          </button>
          <button mat-raised-button color="primary" class="ButtonSmallBlack save-button-group save-button" (click)="submit()"
                  [disabled]="notificationPreferencesForm.pristine || !canSave()">
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
